import { Suspense } from 'react';
import { type Route } from 'type-route';

import { routes } from '../../router';
import { Breadcrumbs } from '../core/breadcrumbs';
import { ErrorBoundary } from '../core/error_boundary';
import { Spinner } from '../core/spinner';
import { SSHKnownHostDeleteModal } from './ssh_known_host_delete_modal';
import { SSHKnownHostInfo } from './ssh_known_host_info';

interface SSHKnownHostDetailProps {
  route: Route<typeof routes.sshKnownHostDetail>;
}

export function SSHKnownHostDetail(props: SSHKnownHostDetailProps) {
  const { route } = props;
  const breadcrumbs = [
    {
      name: 'SSH known hosts',
      link: routes.sshKnownHostList({
        projectId: route.params.projectId,
      }).link,
      current: true,
    },
  ];

  return (
    <div>
      <Breadcrumbs pages={breadcrumbs} />
      <div className="my-2 md:flex md:items-center md:justify-between">
        <div className="min-w-0 flex-1">
          <h1 className="text-2xl font-medium text-gray-900">
            {route.params.sshKnownHostId}
          </h1>
        </div>
        <div className="mt-4 flex flex-shrink-0 md:mt-0 md:ml-6">
          <SSHKnownHostDeleteModal
            projectId={route.params.projectId}
            hostId={route.params.sshKnownHostId}
          />
        </div>
      </div>
      <ErrorBoundary>
        <Suspense fallback={<Spinner />}>
          <SSHKnownHostInfo
            projectId={route.params.projectId}
            hostId={route.params.sshKnownHostId} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}
